/**
 * Valores iniciais do formulário de Activity.
 */
export const activityDefaults = {
    name: "",
    description: "",
    color: "#3b82f6",
    photoUrl: null,
    order: 0,
    xp: 0,
    status: "active",
    evaluationSystem: false,
    objectives: []
};
